import { createSelector } from '@reduxjs/toolkit'
import _ from 'lodash'

export const draftCourse = createSelector(
  (state) => state.eEvaluation,
  (state) => state.courses.map((item) => item.key)
)

export const draftLecturer = createSelector(
  (state) => state.eEvaluation,
  (state) => state.lecturers.map((item) => item.key)
)

export const draftCourseManagement = createSelector(
  (state) => state.eEvaluation,
  (state) => state.courseManagements.map((item) => item.key)
)

export const draftAssessmentQuestion = ({ keyField, keyAssessment, keySub }) =>
  createSelector(
    (state) => state.eEvaluation,
    (state) => {
      const assessmentState = _.get(state, keyField, []).find(
        (item) => item.key == keyAssessment
      )
      if (!keySub) {
        return _.get(assessmentState, 'questions', []).map((item) => item.key)
      }

      const choice = assessmentState.choices.find(
        (item) => item.nextSubQuestionSequence == keySub
      )
      const subQuestion = _.get(choice, 'subQuestions', {})
      return subQuestion.questions.map((item) => item.key)
    }
  )

export const draftQuestion = createSelector(
  (state) => state.eEvaluation,
  (state) => state.questions.map((item) => item.key)
)
